import { render, staticRenderFns } from "./ProductsComposition.vue?vue&type=template&id=2a8d7aa2&scoped=true&"
import script from "./ProductsComposition.vue?vue&type=script&lang=js&"
export * from "./ProductsComposition.vue?vue&type=script&lang=js&"
import style0 from "./ProductsComposition.vue?vue&type=style&index=0&id=2a8d7aa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8d7aa2",
  null
  
)

export default component.exports